export default __webpack_public_path__ + "static/media/attachment.2be9d433.png";